<template>
  <section class="section">
    <div class="container">
      <form @submit.prevent="validateBeforeSubmit">
        <div class="columns">
          <div class="column is-11">
            <h1 class="title green">{{ title }}</h1>
          </div>
          <div class="column has-text-right">
            <button
              type="button"
              class="button is-danger"
              @click="deleteOccurence(mod.id)"
              v-if="mod.id !== 0 && mod.id !== -1 && mod.id != null"
            >
              <b-icon icon="delete-outline"></b-icon>
            </button>
            <button type="submit" class="button is-primary">
              <b-icon icon="content-save-outline"></b-icon>
            </button>
          </div>
        </div>
        <hr />
        <GeneralInfoModel :mod.sync="mod" :module="module"></GeneralInfoModel>
        <hr />
        <h3 class="has-text-centered green subtitle">
          {{ $translate('subtitle_form_model') }}
        </h3>
        <hr />
        <b-tabs position="" class="blocks" vertical>
          <b-tab-item v-if="$moduleConfiguration[module].modelHasTomaio" :label="$translate('tomaio') | capitalize">
            <tomaio
              :module="module"
              ref="tomaio"
              :mod.sync="mod"
              :availablepell.sync="availablepell"
              :availablerip.sync="availablerip"
              :availableallestimenti.sync="availableallestimenti"
              @onReset="resetRip"
            ></tomaio>
          </b-tab-item>
          <b-tab-item v-if="$moduleConfiguration[module].modelHasFodera" :label="$translate('fodera') | capitalize">
            <component :is="fodera" ref="fodera" :mod.sync="mod" :availablefode.sync="availablefode"></component>
          </b-tab-item>
          <b-tab-item
            v-if="$moduleConfiguration[module].modelHasAllacciatura"
            :label="$translate('allacciatura') | capitalize"
          >
            <component
              :is="allacciatura"
              ref="allacciatura"
              :mod.sync="mod"
              :availableallacc.sync="availableallacc"
            ></component>
          </b-tab-item>
          <b-tab-item v-if="$moduleConfiguration[module].modelHasDetails" :label="$translate('details') | capitalize">
            <mod-details :mod.sync="mod"></mod-details>
          </b-tab-item>
          <b-tab-item v-if="$moduleConfiguration[module].modelHasSole" :label="$translate('suola') | capitalize">
            <suola
              v-if="module === 'tailored'"
              ref="suola"
              :mod.sync="mod"
              :availablebatt.sync="availablebatt"
              :availableinter.sync="availableinter"
            ></suola>
            <suola-fits v-else ref="suola" :mod.sync="mod" :availablesoles.sync="availablesoles"></suola-fits>
          </b-tab-item>
          <b-tab-item
            v-if="$moduleConfiguration[module].modelHasRifinitura"
            :label="$translate('rifinitura0') | capitalize"
          >
            <rifinitura
              ref="rifinitura"
              :mod.sync="mod"
              :availableguard.sync="availableguard"
              :availablegomm.sync="availablegomm"
            ></rifinitura>
          </b-tab-item>
          <b-tab-item
            v-if="$moduleConfiguration[module].modelHasAllestimento"
            :label="$translate('allestimento') | capitalize"
          >
            <allestimento
              ref="allestimento"
              :mod.sync="mod"
              :availablecont.sync="availablecont"
              :availablesott.sync="availablesott"
              :availablepunt.sync="availablepunt"
            ></allestimento>
          </b-tab-item>
          <b-tab-item v-if="module === 'insole'" :label="$translate('materials') | capitalize">
            <insole
              ref="insole"
              :mod.sync="mod"
              @onChangeMat="onChangeMat"
              :available-insole-base="availableInsoleBase"
              :available-insole-cover="availableInsoleCover"
              :available-insole-fill="availableInsoleFill"
            ></insole>
          </b-tab-item>
          <b-tab-item v-if="module === 'insole'" :label="$translate('thicknesses') | capitalize">
            <thicknesses :mod.sync="mod"></thicknesses>
          </b-tab-item>
          <b-tab-item v-if="module === 'insole'" :label="$translate('Ins_I') | capitalize">
            <inserts :mod.sync="mod" :available-inserts="availableInserts"></inserts>
          </b-tab-item>
        </b-tabs>
      </form>
    </div>
    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import materialTools from '../../helpers/mixins/materialTools'
//import modelTailored from "../../helpers/mixins/modelTools";
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'

import GeneralInfoModel from './components/GeneralInfoModel'
import tomaio from './components/tomaio'
import fodera from './components/fodera'
import foderaFits from './components/fodera-fits.vue'
import suola from './components/suola'
import suolaFits from './components/suola-fits.vue'
import allacciatura from './components/allacciatura'
import rifinitura from './components/rifinitura'
import allestimento from './components/allestimento'

import permissionMixin from '@/helpers/mixins/permissionMixin'
import allacciaturaFits from './components/allacciatura-fits.vue'
import ModDetails from '@/views/Mod/components/mod-details.vue'
import Insole from '@/views/Mod/components/insole.vue'
import Thicknesses from '@/views/Mod/components/thicknesses.vue'
import Inserts from '@/views/Mod/components/inserts.vue'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'ModForm',
  mixins: [materialTools, permissionMixin, keyWordGenerator],
  components: {
    Insole,
    Thicknesses,
    Inserts,
    ModDetails,
    allestimento,
    allacciatura,
    allacciaturaFits,
    suola,
    suolaFits,
    fodera,
    foderaFits,
    tomaio,
    rifinitura,
    GeneralInfoModel,
  },
  props: {
    module: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      isunique: true,
      id: 0,
      isSaveDisabled: false,
      fodera,
      allacciatura,
      Pel: undefined,
      Rip: undefined,
      Acc: undefined,
      All: undefined,
      Fog: undefined,
      Pun: undefined,
      Mor: undefined,
      Mod: undefined,
      Mez: undefined,
      PaS: undefined,
      Mat: undefined,
      Sug: undefined,
      Pat: undefined,
      Moi: undefined,
      Ric_plan: undefined,
      Rie_plan: undefined,
      Ins: undefined,
      materialKeysArray: [],
      availablepell: [],
      availablefode: [],
      availablebatt: [],
      availableinter: [],
      availableguard: [],
      availablesoles: [],
      availablegomm: [],
      availablerip: [],
      availablecont: [],
      availablesott: [],
      availablepunt: [],
      availableallacc: [],
      availableallestimenti: [],
      availableInsoleBase: [],
      availableInsoleCover: [],
      availableInsoleFill: [],
      availableInserts: [],
      tomaioFieldsToDelete: [],

      mod: {
        addingchar: [],
        components_to_drill: [],
        addingcharfod: [],
        bottomColors: [],
        fogge: [],
        treads: [],
        fodmat: [],
        shapes: [],
        possiblePel: {},
        possibleRip: {},
        sizes: { min: null, max: null },
        thicknesses: { heel_height: 0, ball_height: 0, fings_height: 0, sup_col_med: 0, avvolgenza_mediale: 0 },
        description: '',
        hasDrilledFodera: false,
        hasVelcro: false,
        hasForteAlto: false,
        uniqueComposition: false,
        position: null,
      },
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.module]
    },
  },
  async created() {
    this.setUpMaterialsKeys()
    await this.loadMaterialsData()

    if (this.module === 'fits') {
      this.fodera = foderaFits
      this.allacciatura = allacciaturaFits
    }

    this.isSaveDisabled = true
    this.$validator.extend('unique', async value => {
      let temparray = []
      await this.$db
        .collection(this.config.models)
        .where('name', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              temparray.push(doc.data().name)
            }
          })
        })

      if (temparray.includes(value)) {
        this.isunique = false
        return false
      }
      this.isunique = true
      return true
    })

    this.id = this.$route.params.id !== undefined ? this.$route.params.id : -1
    this.title = this.id !== -1 && this.id !== 0 ? this.$translate('modify_model') : this.$translate('new_model')

    if (this.id !== -1) {
      await this.loadDataToEdit()
    } else {
      if (this.$route.params.idtocopy !== undefined) {
        await this.$db
          .collection(this.config.models)
          .doc(this.$route.params.idtocopy)
          .get()
          .then(doc => {
            this.mod = doc.data()
            this.normalizeModArrays()
            this.mod.id = null
            this.mod.image = null
            this.mod.imagepresent = false
            this.mod.name = null
            return
          })
      }
      this.$set(this.mod, 'position', await this.nextModelPosition())
    }
    this.isSaveDisabled = false
  },

  mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') isAllowed = true
        break
    }
    if (!isAllowed) {
      this.$router.push('/forbidden')
    }
  },

  methods: {
    resetRip() {
      this.mod.possibleRip = []
    },
    normalizeModArrays() {
      for (const key of ['addingchar', 'addingcharfod', 'components_to_drill', 'var_ling_sx', 'var_ling_dx']) {
        if (!this.mod[key]) this.mod[key] = []
      }
    },
    normalizeModelPosition(value) {
      const n = parseInt(value, 10)
      return Number.isInteger(n) && n > 0 ? n : null
    },
    async nextModelPosition() {
      const snapshot = await this.$db
        .collection(this.config.models)
        .orderBy('position', 'desc')
        .limit(1)
        .get()
      let max = 0
      snapshot.forEach(doc => {
        max = this.normalizeModelPosition(doc.data().position) || 0
      })
      return max + 1
    },
    async shiftModelPositions(batch) {
      if (this.mod.position == null) return
      const snapshot = await this.$db
        .collection(this.config.models)
        .where('position', '>=', this.mod.position)
        .orderBy('position')
        .get()
      let expected = this.mod.position
      snapshot.forEach(doc => {
        if (doc.id === this.id) return
        const current = this.normalizeModelPosition(doc.data().position)
        if (current === null || current > expected) return
        batch.update(doc.ref, { position: expected + 1 })
        expected += 1
      })
    },
    async loadDataToEdit() {
      await this.$db
        .collection(this.config.models)
        .doc(this.id)
        .get()
        .then(doc => {
          this.mod = doc.data()
          this.normalizeModArrays()
          if (this.mod.punt_risv === undefined) {
            this.mod.punt_risv = false
          }
        })
    },
    async loadMaterialsData() {
      if (this.Pel) {
        this.getMaterialArray(this.Pel).then(arrayresponse => {
          this.availablepell = arrayresponse
        })
      }

      if (this.Acc) {
        this.getMaterialArray(this.Acc).then(arrayresponse => {
          this.availablefode = arrayresponse
        })
      }

      if (this.All) {
        this.getMaterialArray(this.All).then(arrayresponse => {
          this.availableallacc = arrayresponse
        })
      }

      if (this.Pun) {
        this.getMaterialArray(this.Pun).then(arrayresponse => {
          this.availablebatt = arrayresponse
        })
      }

      if (this.Mor) {
        this.getMaterialArray(this.Mor).then(arrayresponse => {
          this.availableinter = arrayresponse
        })
      }

      if (this.Mat) {
        this.getMaterialArray(this.Mat).then(arrayresponse => {
          this.availableguard = arrayresponse
        })
      }

      if (this.Sug) {
        this.getMaterialArray(this.Sug).then(arrayresponse => {
          this.availablegomm = arrayresponse
        })
      }

      if (this.PaS) {
        this.getMaterialArray(this.PaS).then(arrayresponse => {
          this.availablecont = arrayresponse
        })
      }

      if (this.Pat) {
        this.getMaterialArray(this.Pat).then(arrayresponse => {
          this.availablesott = arrayresponse
        })
      }

      if (this.Mez) {
        this.getMaterialArray(this.Mez).then(arrayresponse => {
          this.availablepunt = arrayresponse
        })
      }

      if (this.Rip) {
        this.getMaterialArray(this.Rip).then(arrayresponse => {
          this.availablerip = arrayresponse
        })
      }

      if (this.Moi) {
        this.getMaterialArray(this.Moi).then(arrayresponse => {
          this.availableInsoleBase = arrayresponse
        })
      }

      if (this.Ric_plan) {
        this.getMaterialArray(this.Ric_plan).then(arrayresponse => {
          this.availableInsoleCover = arrayresponse
        })
      }

      if (this.Rie_plan) {
        this.getMaterialArray(this.Rie_plan).then(arrayresponse => {
          this.availableInsoleFill = arrayresponse
        })
      }

      if (this.Ins) {
        this.getMaterialArray(this.Ins).then(arrayresponse => {
          this.availableInserts = arrayresponse
        })
      }

      if (this.config.soles) {
        this.getMaterialArray(this.config.soles).then(arrayresponse => {
          this.availablesoles = [...arrayresponse].sort((a, b) => this.compareCommercialName(a, b))
        })
      }

      if (this.config.hasRestrictedAllestimentoTomaia) {
        let loadedAllestimenti = []
        this.$db
          .collection('allestimenti')
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let allestimento = doc.data()
              allestimento.id = doc.id
              loadedAllestimenti.push(allestimento)
            })
            this.availableallestimenti = loadedAllestimenti
          })
      }
    },

    validateBeforeSubmit() {
      if (this.config.hasRestrictedAllestimentoTomaia && !this.mod.uniqueComposition) {
        const pellKeys = Object.keys(this.mod || {})
          .filter(k => /^pell\d+mat$/.test(k))
          .filter(k => this.mod[k] !== null)
        const ripKeys = Object.keys(this.mod || {})
          .filter(k => /^rip\d+mat$/.test(k))
          .filter(k => this.mod[k] !== null)
        for (let i = 1; i <= pellKeys.length; i++) {
          if (!this.mod.possiblePel || !this.mod.possiblePel[i]) {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate(`Selezionare l'allestimento per il pellame ${i}`),
              type: 'is-danger',
            })
            return
          }
          if (this.mod.possiblePel[i].length > 0 && !this.mod.possiblePel[i].includes(this.mod[`pell${i}mat`])) {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate(`Il materiale del pellame ${i} non e' incluso nel suo allestimento possibile`),
              type: 'is-danger',
            })
            return
          }
        }
        for (let i = 1; i <= ripKeys.length; i++) {
          if (!this.mod.possibleRip || !this.mod.possibleRip[i]) {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate(`Selezionare l'allestimento per il riporto ${i}`),
              type: 'is-danger',
            })
            return
          }
          if (this.mod.possibleRip[i].length > 0 && !this.mod.possibleRip[i].includes(this.mod[`rip${i}mat`])) {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate(`Il materiale del riporto ${i} non e' incluso nel suo allestimento possibile`),
              type: 'is-danger',
            })
            return
          }
        }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.mod.draft = false
          this.send()
          return
        }
        if (this.mod.name != null && this.isunique) {
          this.mod.draft = true
          this.$buefy.dialog.confirm({
            title: this.$translate('info_dialog_title'),
            message: this.$translate('save_model_message_text'),
            cancelText: this.$translate('undo'),
            confirmText: this.$translate('confirm'),
            type: 'is-info',
            hasIcon: true,
            onConfirm: () => this.send(),
          })
        } else {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        }
      })
    },
    // validatePellAndRip() {
    //   for (let i = 1; i <= this.config.maxPel; i++) {
    //     if (this.mod[`pell${i}mat`]) {
    //       if (!this.mod.possiblePel.includes(this.mod[`pell${i}mat`])) return false
    //     }
    //   }
    //   for (let i = 1; i <= this.config.maxRip; i++) {
    //     if (this.mod[`rip${i}mat`]) {
    //       if (this.mod.possibleRip.length > 0 && !this.mod.possibleRip.includes(this.mod[`rip${i}mat`])) return false
    //     }
    //   }
    //   return true
    // },
    async send() {
      this.isSaveDisabled = true
      if (this.mod.soles) {
        const selectedSoles = this.availablesoles.filter(sole => this.mod.soles.includes(sole.id))
        this.mod.bottomColors = selectedSoles.map(sole => {
          return sole.color.id
        })
        this.mod.fogge = selectedSoles.map(sole => {
          return sole.foggia.id
        })
        const solesWithTreads = selectedSoles.filter(sole => sole.tread.id)
        this.mod.treads = solesWithTreads.map(sole => {
          return sole.tread.id
        })
      }

      if (this.id === 0 || this.id === -1) {
        const cloneDeep = require('clone-deep')
        let modtemp = cloneDeep(this.mod)
        modtemp.imagetoremove = false
        modtemp.imagepresent = false
        modtemp.image = null
        modtemp.rendertoremove = false
        modtemp.renderpresent = false
        modtemp.render = null
        await this.$db
          .collection(this.config.models)
          .add(modtemp)
          .then(docRef => {
            this.id = docRef.id
            this.mod.id = docRef.id
            //console.log(this.mod.id);
          })
      }

      if (this.mod.imagetoremove) {
        this.mod.imagetoremove = false
        let desertRef1 = this.$storage.ref('image/model/' + this.id + '/image')
        await desertRef1
          .delete()
          .then(function() {})
          .catch()
      }

      if (this.mod.image && this.mod.image.name) {
        const storageRef1 = this.$storage.ref('image/model/' + this.id + '/image')

        await storageRef1.put(this.mod.image).then(async snapshot => {
          await snapshot.ref.getDownloadURL().then(url => {
            this.mod.imagepresent = true
            this.mod.image = url
          })
        })
      }

      if (this.mod.rendertoremove) {
        this.mod.rendertoremove = false
        let desertRef2 = this.$storage.ref('image/model/' + this.id + '/render')
        await desertRef2
          .delete()
          .then(function() {})
          .catch()
      }

      if (this.mod.render && this.mod.render.name) {
        const storageRef2 = this.$storage.ref('image/model/' + this.id + '/render')

        await storageRef2.put(this.mod.render).then(async snapshot => {
          await snapshot.ref.getDownloadURL().then(url => {
            this.mod.renderpresent = true
            this.mod.render = url
          })
        })
      }
      this.mod.searchArray = this.generateKeyWord([this.mod.name])
      let batch = this.$db.batch()
      await this.$db
        .collection('catalogs')
        .where('type', '==', this.module)
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let tempcatalog = doc.data()
            if (tempcatalog.model && tempcatalog.model[this.id]) {
              let lookupcatalog = this.$db.collection('catalogs').doc(doc.id)
              // tomaio
              for (let i = 1; i <= this.config.maxPel; i++) {
                this.registerVariant(tempcatalog.material, this.Pel, this.mod[`pell${i}mat`], this.mod[`pell${i}var`])
              }

              if (this.config.modelHasRiporti) {
                for (let i = 1; i <= this.config.maxRip; i++) {
                  this.registerVariant(tempcatalog.material, this.Rip, this.mod[`rip${i}mat`], this.mod[`rip${i}var`])
                }
              }

              // fits / modular
              if (this.module === 'fits' || this.module === 'modular') {
                if (this.mod.treads) {
                  this.mod.treads.forEach(tread => this.registerScalar(tempcatalog.material, this.Pun, tread))
                }
                if (this.mod.fodmat && this.mod.fodmat.length > 0) {
                  this.mod.fodmat.forEach(fodera =>
                    this.registerVariant(tempcatalog.material, this.Acc, fodera.material, fodera.variant.id)
                  )
                }
                if (this.mod.bottomColors) {
                  this.mod.bottomColors.forEach(color => this.registerScalar(tempcatalog.material, this.Col, color))
                }
                if (this.mod.fogge) {
                  this.mod.fogge.forEach(foggia => this.registerScalar(tempcatalog.material, this.Fog, foggia))
                }
              }

              // tailored
              if (this.module === 'tailored') {
                this.registerVariant(tempcatalog.material, this.Pun, this.mod.battmat, this.mod.battvar)
                this.registerVariant(tempcatalog.material, this.Mor, this.mod.intemat, this.mod.intevar)
                this.registerVariant(tempcatalog.material, this.Mor, this.mod.tacczepp, this.mod.tacczeppvar)
                this.registerVariant(tempcatalog.material, this.Mat, this.mod.guardmat, this.mod.guardvar)
                this.registerVariant(tempcatalog.material, this.Sug, this.mod.fascmat, this.mod.fascvar)
                this.registerVariant(tempcatalog.material, this.PaS, this.mod.contrmat, this.mod.contrvar)
                this.registerVariant(tempcatalog.material, this.Pat, this.mod.sottmat, this.mod.sottvar)
                this.registerVariant(tempcatalog.material, this.Mez, this.mod.punmat, this.mod.punvar)
              }

              // insole
              if (this.module === 'insole') {
                this.registerVariant(tempcatalog.material, this.Moi, this.mod.insoleBaseMat, this.mod.insoleBaseVar)
                this.registerVariant(
                  tempcatalog.material,
                  this.Ric_plan,
                  this.mod.insoleCoverMat,
                  this.mod.insoleCoverVar
                )
                this.registerVariant(
                  tempcatalog.material,
                  this.Rie_plan,
                  this.mod.insoleFillMat,
                  this.mod.insoleFillVar
                )
                if (this.mod.inserts) {
                  Object.keys(this.mod.inserts).forEach(section => {
                    this.mod.inserts[section].forEach(slot => {
                      this.registerVariant(tempcatalog.material, this.Ins, slot.material, slot.variant)
                    })
                  })
                }
              }

              batch.update(lookupcatalog, tempcatalog)
            }
          })
        })

      const modelUpdate = this.$db.collection(this.config.models).doc(this.id)
      this.mod.position = this.normalizeModelPosition(this.mod.position)
      await this.shiftModelPositions(batch)
      batch.set(modelUpdate, this.mod)
      batch
        .commit()
        .then(() => {
          this.$forceUpdate()

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
        })
        .catch(() => {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        })

      this.isSaveDisabled = false
    },
    registerVariant(catalog, catKey, mat, variant) {
      if (variant === null || variant === undefined) return
      if (catalog[catKey][mat] === undefined || catalog[catKey][mat].length === 0) {
        catalog[catKey][mat] = {}
      }
      if (!catalog[catKey][mat][variant]) {
        catalog[catKey][mat][variant] = true
      }
    },
    registerScalar(catalog, catKey, value) {
      if (value === null || value === undefined) return
      if (catalog[catKey][value] === undefined || catalog[catKey][value].length === 0) {
        catalog[catKey][value] = {}
      }
      if (!catalog[catKey][value]) {
        catalog[catKey][value] = true
      }
    },
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('model_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('model_message_confirm'),

        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.isSaveDisabled = true
          this.$db
            .collection(this.config.models)
            .doc(idtoerase)
            .delete()
            .then(() => {
              this.isSaveDisabled = false
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
              this.$router.push({ name: 'mods' })
            })
        },
      })
    },
    setUpMaterialsKeys() {
      this.Pel = this.config.materials.Pel
      this.Fog = this.config.materials.Fog
      this.Acc = this.config.materials.Acc
      this.All = this.config.materials.All
      this.Pun = this.config.materials.Pun
      this.Mor = this.config.materials.Mor
      this.Mod = this.config.materials.Mod
      this.Mez = this.config.materials.Mez
      this.PaS = this.config.materials.PaS
      this.Mat = this.config.materials.Mat
      this.Sug = this.config.materials.Sug
      this.Pat = this.config.materials.Pat
      this.Col = this.config.materials.Col
      this.Rip = this.config.materials.Rip
      this.Moi = this.config.materials.Moi
      this.Ric_plan = this.config.materials.Ric_plan
      this.Rie_plan = this.config.materials.Rie_plan
      this.Ins = this.config.materials.Ins
    },
    onChangeMat({ key, value }) {
      this.$set(this.mod, key, value)
    },
  },
}
</script>
